const rawAxios = require("axios");

export function axios(token) {
  return rawAxios.create({
    baseURL: process.env.VUE_APP_API,
    headers: { authorization: `Bearer ${token}` }
  });
}
